import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';

import OAuthConsent from '../components/OAuthConsent/OAuthConsent';

function mapStateToProps(state) {
  return {
    currentUser: state.currentUser,
  };
}

export default withRouter(withTranslation()(connect(mapStateToProps)(OAuthConsent)));
